var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Select',{attrs:{"selected":_vm.selectedId,"clearable":true,"data":_vm.lists,"placeholder":"请选择"},on:{"update:selected":function($event){_vm.selectedId=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }